import {Component, Input} from '@angular/core';
import {HtmlUtilsService} from '../../html-utils/html-utils.service';
import {NavBaseComponent} from '../nav-base/nav-base.component';

@Component({
  selector: 'app-nav-help',
  templateUrl: './nav-help.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss']
})
export class NavHelpComponent extends NavBaseComponent{

  @Input() forceStartIndexTab = true;

  constructor(private htmlUtils: HtmlUtilsService){
    super();
  }

  resetPlusSize() {
    this.htmlUtils.resetPlusSize();
  }

  togglePlusSize() {
    this.htmlUtils.togglePlusSize();
  }

  togglePlusPlusSize() {
    this.htmlUtils.togglePlusPlusSize();
  }

  toggleContrast() {
    this.htmlUtils.toggleContrast();
  }

}
